import PaymentView from "./view";
import { useViewModel } from "./viewModel";

export default function Payment() {
  const vm = useViewModel();
  return <PaymentView {...vm} />;
}
